import Swiper from "swiper/swiper-bundle.mjs";

const carouselEl = document.querySelector(".carousel");

const carousel = carouselEl
  ? new Swiper(carouselEl, {
      init: false,
      pagination: {
        el: ".swiper-pagination",
        type: "dots",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  : null;

const initSwiper = () => {
  if (carousel) {
    carousel.init();
  }
};

export default initSwiper;
